import { NarrowPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { Result } from "antd";
import { RootRoute } from "route-components/RootRoute";
import { createRootRoute } from "@tanstack/react-router";

/** The layout for payments dashboard. */
export const Route = createRootRoute({
    component: RootRoute,
    notFoundComponent: () => (
        <NarrowPageContentContainer>
            <Result
                status="404"
                title="Not found"
                subTitle="We couldn't find the page you're looking for. Please try the main menu on the left."
            />
        </NarrowPageContentContainer>
    ),
});
